<template>
  <div>
    <swiper
      ref="mySwiper"
      :options="swiperOption">
      <swiper-slide
        v-for="(image, index) in images"
        :key="index">
        <a
          :href="image.url"
          target="_blank">
          <base-image
            class="swiper-img"
            encrypt
            :lazy="false"
            :ratio="650/300"
            :url="image.imgbase64.url"
            :type="image.imgbase64.type" />
        </a>
      </swiper-slide>
      <div
        v-if="swiperOption.pagination"
        class="swiper-pagination"
        slot="pagination"></div>
    </swiper>
  </div>
</template>
<script>
import baseImage from '@/components/baseImage'
import '../assets/css/swiper.min.css'
export default {
  name: 'banner',
  components: {
    baseImage
  },
  props: { images: Array, swiperOption: null }
}
</script>
<style scoped>
.swiper-img {
  width: 100%;
  overflow: hidden;
  border-radius: 10px;
}

.swiper-inner {
  width: 100%;
  height: 220px;
  padding-top: 50px;
  padding-bottom: 50px;
  border-radius: 10px;
}

.swiper-slide {
  width: 90% !important;
  background-position: center;
  background-size: cover;
  border-radius: 10px;
}

.swiper-container-v {
  background: #eee;
}

.swiper-container-v .swiper-slide {
  width: 100%;
  background: #eee;
}

.swiper-pagination-bullet {
  background: #ddd;
  opacity: 0.5;
}

.swiper-pagination-bullet-active {
  width: 16px;
  background: #fff !important;
  border-radius: 4px;
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/banner.vue